import React from 'react';
import DropDown from './components/dropdown/index';
import {dropDownPosition, permissionCleaner} from '../../../../../../../../../../../../../../../../utils/index';
import {connect} from 'react-redux';
import Icon from '../../../../../../../../../../../../../../../../components/icon/index';
import {
    checkUpdates,
    flash,
    getChangedStatus, ownershipChangeTarget,
    updateCollaborators
} from '../../../../../../../../../../../../../../../../../actions/sharingDetailsActions';
import './index.css';


class SelectRights extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			rightState : null,
			isDropDown : false
		};

		this.update = this.update.bind(this);
		this.toggleDropDown = this.toggleDropDown.bind(this);
		this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);
	}

	toggleDropDown(e){

		let cTarget = e.currentTarget;

		if(this.props.flash){
			this.props.setFlash(null);
		}

		this.setState((state) => ({
			isDropDown: !state.isDropDown
		}), () => {
            dropDownPosition(document.querySelector('.list-of-collaborators-details-content'), cTarget, cTarget.nextSibling);
		});

	}

	update(right){

		this.setState({
			rightState: right
		});

		let contributorsToUpdate = [];
		let {updateCollaborators, collaboratorId} = this.props;
		let newCollaboratorToUpdate = true;

		if(this.props.updateCollaborators.length > 0){

			/*
			* A collaborator update has already occurred
			* */

			if (this.state.rightState === "OWNER") {

				/*
				* Only one new Owner can be chosen
				* */

				updateCollaborators.find(updateCollaborator => {
					if(updateCollaborator.id !== collaboratorId){

						/*
						* Uncheck Owner on other collaborators' permission
						* */

						if(updateCollaborator.permission === "OWNER"){
							updateCollaborator.permission = "CAN_SHARE";
						}

					}

					return null;
				});
			} else {
				this.props.setOwnershipChangeTarget(null);
			}

			this.props.findCollaborators.collaborators.forEach(collaborator => {
				updateCollaborators.forEach(updateCollaborator => {

					if(collaborator.id === updateCollaborator.id){

						/*
						*  Collaborator is inside the collaborators to update
						* */

						if(updateCollaborator.id === collaboratorId){

							newCollaboratorToUpdate = false;

							/*
							*  Collaborator is the one we have clicked on
							* */

							let collaboratorToUpdate = {
								groupId: this.props.sharingDetailsPopup[2] || this.props.selectedContactsGroup.id,
								id: updateCollaborator.id,
								email: updateCollaborator.email,
								permission: right,
								type: updateCollaborator.type,
								addToContact: updateCollaborator.addToContact,
								toRemove: updateCollaborator.toRemove,
							};

							if(
								collaborator.id === collaboratorToUpdate.id &&
								collaborator.email === collaboratorToUpdate.email &&
								collaborator.permission === collaboratorToUpdate.permission &&
								collaborator.type === collaboratorToUpdate.type &&
								collaborator.addToContact === collaboratorToUpdate.addToContact &&
								collaborator.toRemove === collaboratorToUpdate.toRemove
							){
								contributorsToUpdate = [
									...updateCollaborators.filter((item) => item.id !== updateCollaborator.id)
								];
								this.props.setUpdateCollaborators(contributorsToUpdate);

								//this.props.getChangedStatus(false);
							} else {
								contributorsToUpdate = [
									...updateCollaborators.filter((item) => item.id !== updateCollaborator.id),
									collaboratorToUpdate
								];
								this.props.setUpdateCollaborators(contributorsToUpdate);
							}
						}

					}
				});

				if(newCollaboratorToUpdate){
					if (collaborator.id === collaboratorId) {
						this.props.setUpdateCollaborators(
							[
								...updateCollaborators,
								{
									groupId: this.props.sharingDetailsPopup[2] || this.props.selectedContactsGroup.id,
									id: collaborator.id,
									email: collaborator.email,
									permission: right,
									type: collaborator.type,
									addToContact: collaborator.addToContact,
									toRemove: collaborator.toRemove
								}
							]
						)
					}
				}



			});

		} else {

			/**
			 * First collaborator update
			 */

			this.props.findCollaborators.collaborators.find(collaborator => {

				if (collaborator.id === collaboratorId) {
					this.props.setUpdateCollaborators([{
						groupId: this.props.sharingDetailsPopup[2] || this.props.selectedContactsGroup.id,
						id: collaborator.id,
						email: collaborator.email,
						permission: right,
						type: collaborator.type,
						addToContact: collaborator.addToContact,
						toRemove: collaborator.toRemove
					}]);
				}

				return null;

			})

		}

        this.props.checkUpdates();

	}

	mouseLeaveHandler(){

        this.setState({
            isDropDown: false
        });

	}

    render(){
		return (
			<div onMouseLeave={this.mouseLeaveHandler} className={`select-rights`}>
			    <div data-collaborator-id={this.props.collaboratorId} className="select d-flex align-items-center justify-content-end" onClick={this.toggleDropDown}>
				    {permissionCleaner(this.state.rightState !== null ? this.state.rightState : this.props.content) }
				    <div className="arrow">
					    <Icon name="caret-down"/>
				    </div>
			    </div>
				{
					this.state.isDropDown ?
                        <DropDown
                            profileDomainName={this.props.profile.domain.name}
                            collaboratorId={this.props.collaboratorId}
                            collaboratorEmail={this.props.collaboratorEmail}
                            collaboratorType={this.props.collaboratorType}
                            userRole={this.props.userRole}
                            getUpdatedRight={this.update}
                            right={this.state.rightState ? this.state.rightState : this.props.content}
                            userPermission={this.props.selectedContactsGroup.permission}
							internal={this.props.internal}
                        />
						: null
				}
			</div>
		)
    }
}

const mapStateToProps = (state) => {
	return {
		selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
		findCollaborators: state.sharingDetailsReducer.findCollaborators,
		rightId: state.sharingDetailsReducer.rightId,
		rightScore: state.sharingDetailsReducer.rightScore,
        sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
		updateCollaborators: state.sharingDetailsReducer.updateCollaborators,
		flash : state.sharingDetailsReducer.flash,
        profile : state.profileReducer.getProfile
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getChangedStatus : (boolean) => {
			dispatch(getChangedStatus(boolean))
		},
		setUpdateCollaborators : (array) => {
			dispatch(updateCollaborators(array))
		},
        checkUpdates : () => {
            dispatch(checkUpdates())
        },
		setFlash : (array) => {
			dispatch(flash(array))
		},
		setOwnershipChangeTarget : (boolean) => {
			dispatch(ownershipChangeTarget(boolean))
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectRights);
